/// <reference types="node" />
export var CLIENT_VERSION = "5.5.3";